import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useNotificationsStore } from 'ah-notifications/src/store';
import NotificationsList from './NotificationsList.vue';
import { isDescendant } from 'ah-common-lib/src/helpers/dom';
import NotificationActionButtons from './NotificationActionButtons.vue';
import { useRouter } from 'vue-router/composables';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { Notification } from 'ah-api-gateways';
import WarningSplash from 'bd-common/src/components/common/WarningSplash.vue';
import LoadingSplash from '../common/LoadingSplash.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsTooltip',
  props: {
    type: { default: 'notification' }
  },
  setup(__props: any, { expose }) {

const props = __props as { type: 'notification' | 'file_export' };



const isTooltipShown = ref(false);

const rootRef = ref<HTMLElement | null>(null);

let clickListener: (event: MouseEvent) => void;

const notificationsStore = useNotificationsStore();

const router = useRouter();

const isNotificationsEmpty = computed(() => notifications.value.length === 0);

const isMoreThanFive = computed(() => notifications.value.length > 5);

const unreadCount = computed(() =>
  props.type === 'notification' ? notificationsStore.unreadCount : notificationsStore.fileExportUnreadCount
);

const isAllRead = computed(() => unreadCount.value === 0);

const handleMarkAllAsRead = () => {
  notificationsStore.markAllAsRead(props.type === 'notification' ? 'notifications' : 'fileExports');
};

function toggleTooltip(show: boolean = !isTooltipShown.value) {
  // Run in next tick to avoid click event propagation issues
  setTimeout(() => {
    isTooltipShown.value = show;
  }, 0);
}

function navigateToNotificationsPage() {
  const currentRoutePath = router.currentRoute.fullPath;
  router.push({
    path: props.type === 'notification' ? '/app/notifications' : '/app/downloads',
    query: {
      fromRoute: currentRoutePath,
    },
  });
}

function hideToogleTooltip() {
  isTooltipShown.value = false;
}

function handleSeeAllClick() {
  toggleTooltip();
  navigateToNotificationsPage();
}

onMounted(() => {
  clickListener = (event) => {
    if (isTooltipShown.value && (!rootRef.value || !isDescendant(rootRef.value, event.target as Element, true))) {
      hideToogleTooltip();
    }
  };

  window.addEventListener('click', clickListener);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', clickListener);
});

const notifications = computed(() => {
  const out: Notification[] = [];
  const notifArray =
    props.type === 'notification' ? notificationsStore.notifications : notificationsStore.fileExportNotifications;

  out.push(...notifArray.slice(0, 5));

  return out;
});

const loading = computed(() => notificationsStore.loading);

expose({
  toggle: toggleTooltip,
  show: () => !isTooltipShown.value && toggleTooltip(true),
  hide: () => isTooltipShown.value && toggleTooltip(false),
});

return { __sfc: true,props, isTooltipShown, rootRef, clickListener, notificationsStore, router, isNotificationsEmpty, isMoreThanFive, unreadCount, isAllRead, handleMarkAllAsRead, toggleTooltip, navigateToNotificationsPage, hideToogleTooltip, handleSeeAllClick, notifications, loading, NotificationsList, NotificationActionButtons, MaterialIcon, WarningSplash, LoadingSplash }
}

})